import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state';
import { API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_PATH_KEY } from '@/swagger/constants/surveys-keys';
import { API_GET_SURVEYS_CAMPAIGNS_CALL, KEY_GET_SURVEYS_CAMPAIGNS } from '../constats';
import { MOCK_RESPONSE_GET_SURVEYS_CAMPAIGNS } from '../mocks';

type RequestGetSurveysCampaigns = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_PATH_KEY
>['request']['query'];

type ResponseGetSurveysCampaigns = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_PATH_KEY
>['response']['body'];

type CallParamsGetSurveysCampaigns = RequestGetSurveysCampaigns & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponseGetSurveysCampaigns = ResponseGetSurveysCampaigns;

type CallErrorGetSurveysCampaigns = GenericApiError;

type CallSelectorsGetSurveysCampaigns = unknown;

export const getSurveysCampaignsCall = createGeneralCall<
  CallParamsGetSurveysCampaigns,
  CallResponseGetSurveysCampaigns,
  CallErrorGetSurveysCampaigns,
  CallSelectorsGetSurveysCampaigns
>({
  id: KEY_GET_SURVEYS_CAMPAIGNS,
  method: 'get',
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_GET_SURVEYS_CAMPAIGNS_CALL(org, payload);
    },
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_GET_SURVEYS_CAMPAIGNS : undefined,
});
